import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import formatDateArabicDZ from "../utils/formatDate";
const TableRow = ({
  id,
  uiid,
  item_description,
  quantity,
  showEditItem,
  handleDeleteItem,
  supplier,
  date,
  userType,
  n,
}) => (
  <tr
    key={id}
    className="align-middle text-center"
    style={{ fontSize: "12px" }}
  >
    <td>{n}</td>

    <td>{item_description}</td>
    <td>{quantity}</td>
    {/* <td>
      {supplier ? supplier : <span className="text-danger"> لا يوجد</span>}
    </td> */}
    <td>{formatDateArabicDZ(date)}</td>
    <td>
      {/* <button
        className="btn border border-1"
        title="Edit"
        onClick={() => showEditItem(uiid)}
      >
        <FontAwesomeIcon icon={faPen} size="lg" />
      </button> */}
      {userType === "admin" && (
        <button
          className="btn border border-1 ms-3"
          title="Delete"
          onClick={() => handleDeleteItem(uiid)}
        >
          <FontAwesomeIcon icon={faTrashCan} size="lg" />
        </button>
      )}
    </td>
  </tr>
);

const StoreTableRow = ({ showEditItem, handleDeleteItem, data, userType }) => (
  <>
    {data.map((item, idx) => (
      <TableRow
        n={idx + 1}
        key={item.id}
        id={item.id}
        uiid={item.item_uuid}
        item_description={item.item_name}
        quantity={item.quantity}
        showEditItem={showEditItem}
        handleDeleteItem={handleDeleteItem}
        supplier={item.supplier}
        date={item.addition_date}
        userType={userType}
      />
    ))}
  </>
);

export default StoreTableRow;
